import { render, staticRenderFns } from "./BotAnalytics.vue?vue&type=template&id=d2411e52&"
import script from "./BotAnalytics.vue?vue&type=script&lang=js&"
export * from "./BotAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./BotAnalytics.vue?vue&type=style&index=0&id=d2411e52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports